import options from './temperature.component';


export default {
    selector: "dtEmulatorTemperature",
    options
}